import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  >Form {
    width: 100%;
  }
`;